var map = {
	"./GettyImages-1059166634.jpg": 673,
	"./HERO_Pycnandra_latex_credit_Antony_van_der_Ent_2.jpg": 674,
	"./Handbag_Thumb_cropped.jpg": 675,
	"./Hero-Alamy.jpg": 676,
	"./Ilulissat_Ice_fjord_Greenland_credit_BBC.jpg": 677,
	"./Poppies-BBC.jpg": 678,
	"./Weeds-Reuters.jpg": 679,
	"./Woman_on_bike_4_credit_Sharon_Tshipa.jpg": 680,
	"./bicycles.jpg": 681,
	"./chilly_alamy.jpg": 682,
	"./coffee-unstoppable-force.jpg": 683,
	"./decaffeine.jpg": 684,
	"./drinking_water.jpg": 685,
	"./dry-tap-getty.jpg": 686,
	"./healthy_coffee.jpg": 687,
	"./hero_beach_getty.jpg": 688,
	"./hero_brighton_getty.jpg": 689,
	"./milk.jpg": 690,
	"./mind_chip.jpg": 691,
	"./paper-comeback.jpg": 692,
	"./proposed_hero.jpg": 693,
	"./semiconductors.jpg": 694,
	"./smell.jpg": 695,
	"./spice.jpg": 696,
	"./straws.jpg": 697,
	"./traffic_jams.jpg": 698,
	"./whisky_Getty_cropped.jpg": 699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 672;